'use client';
import { Avatar, AvatarGroup } from '@mui/material';
import { title } from 'process';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';

export type CustomerType = {
    id: number;
    email: string;
}
const stringToColor = (str: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

const  stringAvatar = (label: string) => {
  return {
    sx: {
      //bgcolor: stringToColor(label),
      bgcolor: `${stringToColor(label)} !important`
    },
    children: `${label.split(' ')[0][0].toUpperCase()}${label.split(' ')[0][1].toUpperCase()}`,
    title: label
  };
}


const Customer = ({customers}: {customers: CustomerType[]}) => {
  const { theme } = useJumboTheme();
  return (
    <AvatarGroup
      max={4}
      sx={{
        '& .MuiAvatar-root': {
          width: 35,
          height: 35,
        },
      }}
    >
      {customers.map((customer, index) => (
        <Avatar 
          alt={customer.email} 
          key={index} 
          {...stringAvatar(customer.email)}
        />
      ))}
    </AvatarGroup>
  );
};

export { Customer };
